import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { SettingsRulesEditorService } from '@app/services/settings/srules.service';

import { MultiSelectItem } from '@core/models/select-item.model';

import * as fromRulesModel from '@app/models/rules';

interface VariableInput {
    key: string;
    value: string | Array<string>;
    options?: Object;
};

@Component({
  selector: 'settings-rules-rule-form-actions-variable-item',
  templateUrl: './actions-variable-item.component.html',
  styleUrls: ['./actions-variable-item.component.scss'],
})
export class SettingsRulesRuleFormActionsVariableItemComponent implements OnInit{
    // IMPORTANT: those are the keys for what we have to show action searchable selector
    public readonly ACTION_LABELS_SEARCHABLE_KEYS = ['access_request_labels','access_version_labels'];

    @Input() availableVariables: Array<fromRulesModel.AvailableRuleActionVariable> = [];
    @Input() actionForm: fromRulesModel.AvailableRuleItemForm; //RuleAction;
    @Input() variable: VariableInput; //fromRulesModel.AvailableRuleActionVariable; {key: string, value: any }
    @Input() ruleActionsConfigured: fromRulesModel.RuleAction; // rule action configured in current rule. TO check for emptyness
    @Output() selectValue = new EventEmitter<VariableInput>();

    public options: Array<MultiSelectItem> = [];
    public term: string = '';
    public found: Array<fromRulesModel.AvailableRuleConditionValueItem> = [];
    public placeholder: string = "";

    constructor(protected editorSrv: SettingsRulesEditorService){}

    ngOnInit(): void {
        this.term = this.actionForm.search.term;
        this.found = this.actionForm.search.found;
        // We need to set a placeholder error when a key is not set in the current editing rule
        if( !this.ruleActionsConfigured.parameters.hasOwnProperty(this.variable.key)){
            this.placeholder = "This value is not set";
        }
    }

    onSelectAction(e: fromRulesModel.AvailableRuleItem){
        // console.log("select--->", e);

        let ret = {
            key: this.variable.key,
            value: e.key
        }

        this.selectValue.emit(ret);
    }

    onSelectActionMultiple(itemsSelected: Array<fromRulesModel.AvailableRuleItem>){
        // console.log("multiselect--->", itemsSelected);

        let ret = {
            key: this.variable.key,
            value: itemsSelected.map((v: fromRulesModel.AvailableRuleItem) => v.key)
        }

        this.selectValue.emit(ret);
    }

    getAvailableVariable(key: string) {
        let variables = this.availableVariables.filter( v => v.key == key);
        // availableVariables
        return variables[0];
    }

    // term for search change
    onSetTerm(term: string) : void {
        this.term = term;
        //  set term on this form in the store to set found values
        this.editorSrv.setRuleActionsFormTerm(this.actionForm, this.variable.key, term);
    }


}
